.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
}

.tile {
  background: var(--color-card, #fff);
  border: 1px solid var(--color-border, #d4d4d8);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.tile-thumb {
  border-color: var(--color-primary, #18181b);
  box-shadow: 0 0 0 1px var(--color-primary, #18181b);
}

.tile-dragging {
  opacity: 0.5;
}

.tile-image {
  background-color: var(--color-muted, #f4f4f5);
  height: 110px;
  object-fit: cover;
  width: 100%;
}

.tile-actions {
  align-items: center;
  background: var(--color-card, #fff);
  border-top: 1px solid var(--color-border, #d4d4d8);
  display: flex;
  gap: 4px;
  justify-content: space-between;
  padding: 6px 8px;
}

.tile-actions button {
  background: transparent;
  border: 0;
  color: var(--color-muted-foreground, #71717a);
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  padding: 4px 6px;
}

.tile-actions button:hover {
  color: var(--color-foreground, #18181b);
}

.thumbnail-badge {
  background: var(--color-primary, #18181b);
  border-radius: 4px;
  color: var(--color-primary-foreground, #fff);
  font-size: 10px;
  font-weight: 600;
  left: 6px;
  padding: 2px 6px;
  position: absolute;
  text-transform: uppercase;
  top: 6px;
}

.toolbar {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.toolbar-button {
  background: var(--color-card, #fff);
  border: 1px solid var(--color-border, #d4d4d8);
  border-radius: 6px;
  color: var(--color-foreground, #18181b);
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 12px;
}

.toolbar-button:hover {
  background-color: var(--color-muted, #f4f4f5);
}

.empty {
  border: 2px dashed var(--color-border, #d4d4d8);
  border-radius: 8px;
  color: var(--color-muted-foreground, #71717a);
  font-size: 13px;
  padding: 24px;
  text-align: center;
}
